import { render, staticRenderFns } from "./LanguageField.vue?vue&type=template&id=5ccf8d96&scoped=true&"
import script from "./LanguageField.vue?vue&type=script&lang=js&"
export * from "./LanguageField.vue?vue&type=script&lang=js&"
import style0 from "./LanguageField.vue?vue&type=style&index=0&id=5ccf8d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccf8d96",
  null
  
)

export default component.exports